import React from 'react';
import NumberFormat from 'react-number-format';
import { H4 } from './Text';
import ReactTooltip from 'react-tooltip';

export const PriceCard = (props) => {
  let currentPrice = props.currentPrice;
  let suffix = '';
  let decimalPrecision = 2;

  if (Math.round(currentPrice).toString().length >= 6) {
    currentPrice = props.currentPrice / 1000;
    suffix = 'k';
    decimalPrecision = 0;
  }

  return (
    <div className="mb4">
      <div className="br2 cf bg-white shadow-custom">
        <div className="fl w-33 br b--light-gray pa3">
            Current Price
          <h1 className="f2 f1-l fw2 ma0 mt4">
          <NumberFormat value={props.currentPrice.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} suffix={suffix} decimalScale={decimalPrecision} />
          </h1>
          <span className="f5">
            <span className={props.marketChange > 0 ? "green" : "red"}>
              <NumberFormat value={props.marketChange.toFixed(2)} displayType={'text'} prefix={'$'} suffix={' '} />
              (<NumberFormat value={props.marketChangePercent.toFixed(2)} displayType={'text'} suffix={'%'} />)
              <span className="f7 ml2">{props.marketChange > 0 ? '▲' : '▼'}</span>
            </span>
          </span>
        </div>

        <div className="fl w-33 br b--light-gray pa3">
          <H4>
            Price Momentum
            <i data-tip data-for='priceMomentum' className="material-icons light-silver f4 pointer">help_outline</i>
          </H4>
          <ReactTooltip id='priceMomentum' place='top' className='mw6'>
            <p className="f6">Price Momentum reflects recent market sentiment towards the stock.</p>
          </ReactTooltip>
          <h1 className="f2 f1-l fw2 ma0 mt4">
            <NumberFormat value={props.priceMomentum.toFixed(2)} displayType={'text'} />
          </h1>
          <span className="light-silver">
            <span className="f5">{props.priceMomentum >= 1.0 ? 'Advancing' : 'Declining'}</span>
            <span className="f7 ml2">{props.priceMomentum >= 1.0 ? '▲' : '▼'}</span>
          </span>
        </div>

        <div className="fl w-33 pa3">
          <H4>
            Operations Type
            <i data-tip data-for='opsType' className="material-icons light-silver f4 pointer">help_outline</i>
          </H4>
          <ReactTooltip id='opsType' place='top' className='mw6'>
            <p className="f6">Polaris designates companies as "Stable" or "Dynamic"...</p>
          </ReactTooltip>
          <h1 className="f2 f1-l fw2 ma0 mt4">
            <span>{props.opsType >= 1.0 ? 'Dynamic' : 'Stable'}</span>
          </h1>
        </div>
      </div>
    </div>
  );
};

export const NumberCard = (props) => {
  let prefix = '$'
  let decimalPrecision = 2
  let thousandSeparator = true
  let suffix = null
  let current = props.current
  let practical = props.practical
  let theoretical = props.theoretical

  if (props.numberType === '%') {
    suffix = '%'
    thousandSeparator = null
    prefix = null
    decimalPrecision = 1
  }


  if (props.title === 'Valuation') {
    if (Math.round(props.current).toString().length >= 6) {
      current = props.current / 1000;
      practical = props.practical / 1000;
      theoretical = props.theoretical / 1000;
      decimalPrecision = 0
      suffix = 'k'
    }
  }

  const renderInvestmentReturnColor = (number) => {
    let sp500 = 7.5;

    if (number > sp500) {
      return 'black'
    } else {
      return 'black'
    }
  }

  return (
    <div className="br2 cf bg-white shadow-custom pa3 mb3">
      <span className="dib-ns"><H4>{props.title}</H4></span>
      <div className="dib-ns fr-ns w-60-ns mt3 ma0-ns">

        <div key="current" className="cf bt b--light-gray bn-ns fl-ns w-third-ns pv2">
          <h2 className="f5 f3-m f2-l ma0 fw2-ns fw5 fr fn-ns" >
            {props.title === 'Investment Return' ? (
              <NumberFormat className={renderInvestmentReturnColor(current)} value={current} displayType={"text"} decimalPrecision={decimalPrecision} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
            ) : (
              <NumberFormat value={current} displayType={"text"} decimalPrecision={decimalPrecision} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
            )}
          </h2>
          <span className="f5 f6-ns gray fl fn-ns">Market</span>
          <i data-tip data-for='market' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='market' place='top' class='mw6'>
            <p className="f6">Market values are based on the assumption that the stock market is efficient and has priced the stock such that the current price equals the company’s value.</p>
          </ReactTooltip>
        </div>

        <div key="practical" className="cf bt b--light-gray bn-ns fl-ns w-third-ns pv2">
          <h2 className="f5 f3-m f2-l ma0 fw2-ns fw5 fr fn-ns">
            {props.title === 'Investment Return' ? (
              <NumberFormat className={renderInvestmentReturnColor(practical)} value={practical} displayType={"text"} decimalPrecision={decimalPrecision} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
            ) : (
              <NumberFormat value={practical} displayType={"text"} decimalPrecision={decimalPrecision} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
            )}
          </h2>
          <span className="f5 f6-ns gray fl fn-ns">Practical</span>
          <i data-tip data-for='practical' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>
          <ReactTooltip id='practical' place='top' class='mw6'>
            <p className="f6">Practical values are based on the Theoretical valuation, current price, and estimates of the market's likely reassessment of the company's sales growth and risk.</p>
          </ReactTooltip>       
        </div>

        <div key="theoretical" className="cf bt bb b--light-gray bn-ns fl-ns w-third-ns pv2">
          <h2 className="f5 f3-m f2-l ma0 fw2-ns fw5 fr fn-ns">
            {props.title === 'Investment Return' ? (
              <NumberFormat className={renderInvestmentReturnColor(theoretical)} value={theoretical} displayType={"text"} decimalPrecision={decimalPrecision} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
            ) : (
              <NumberFormat value={theoretical} displayType={"text"} decimalPrecision={decimalPrecision} thousandSeparator={thousandSeparator} prefix={prefix} suffix={suffix}/>
            )}
          </h2>
          {props.title === 'Sales Growth' ? (
             <span className="f5 f6-ns orange fl fn-ns">Slider Value</span>   
            ) : (
            <span className="f5 f6-ns gray fl fn-ns">Theoretical</span>
          )}
          <i data-tip data-for='theoretical' className="material-icons light-silver f5 pointer v-mid ml1">help_outline</i>

              <ReactTooltip id='theoretical' place='top' class='mw6'>
                <p className="f6">Theoretical valuation = (Dividend)(5) + ((Current Sales)((1+gs)^5)(FuturePM/FutureShares)(FuturePE)/((1+CoE)^5). This is the present value of the company's risk adjusted, projected cash flows. Slider values on the right are used as inputs.</p>
              </ReactTooltip>
        </div>

      </div>

      <p className="db-ns w-40-ns gray f6 ma0 mt2 pr4-ns">{props.description}</p>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/InfoCard.js